export const computeWidths = (distributeWidth: number, amount: number): number[] => {
  // If no non-fillers, just return an empty array (or handle differently)
  if (amount <= 0) {
    return [];
  }

  // If exactly one non-filler, it takes all the distributeWidth
  if (amount === 1) {
    return [distributeWidth];
  }

  // Otherwise (2 or more non-fillers):
  const widths: number[] = [];
  const baseWidth = Math.floor(distributeWidth / amount);

  // 1) Fill the first (n - 2) items
  for (let i = 0; i < amount - 2; i++) {
    widths.push(baseWidth);
  }

  // 2) Calculate leftover for the last two
  const sumSoFar = widths.reduce((a, b) => a + b, 0);
  const leftover = distributeWidth - sumSoFar;
  const secondToLast = Math.floor(leftover / 2);
  const last = leftover - secondToLast;

  widths.push(secondToLast, last);
  return widths;
}
export const computeProportionalWidths = (totalWidth: number, factors: number[]): number[] => {
  const totalFactor = factors.reduce((sum, f) => sum + f, 0);
  // If no factors (or they sum to zero), fall back to equal distribution.
  if (totalFactor === 0) {
    return computeWidths(totalWidth, factors.length);
  }
  // Get the "ideal" (floating point) widths
  const idealWidths = factors.map(f => totalWidth * (f / totalFactor));
  // Floor each ideal width.
  const flooredWidths = idealWidths.map(val => Math.floor(val));
  // Calculate the remainder (the pixels that were lost to flooring)
  let remainder = totalWidth - flooredWidths.reduce((sum, val) => sum + val, 0);
  // Determine the fractional parts
  const fractions = idealWidths.map((val, i) => val - flooredWidths[i]);
  const result = [...flooredWidths];
  // Distribute the remainder one by one to the items with the largest fractions.
  while (remainder > 0) {
    let maxIndex = 0;
    for (let i = 1; i < fractions.length; i++) {
      if (fractions[i] > fractions[maxIndex]) {
        maxIndex = i;
      }
    }
    result[maxIndex] += 1;
    fractions[maxIndex] = 0; // Reset so it isn’t picked repeatedly.
    remainder--;
  }
  return result;
};
